/**
 * Created by SH: 02/20/2020
 */

import { gsap, Bounce } from 'gsap';
import { Point } from "pixi.js";
import { ReelEngineManager } from "../../dev/reel/ReelEngineManager";
import { IDimOrientation, LayoutDimData, ResizeHelper } from "../../dev/utils/ResizeHelper";

import { RoadRageEngineController } from "./RoadRageEngineController";
import { IReelConfig } from "../../dev/reel/IData/IReelData";
import { ReelGameData } from "../server/data/GameDataModels";
import { DebugButton } from "./DebugButton"
import { GameSetting } from "../../dev/setting/GameSetting";
import { RoadRageSpriteSymbol } from "./symbol/RoadRageSpriteSymbol";
import { ArrayHelper } from '../../dev/utils/ArrayHelper';
import { Helper } from '../../dev/utils/Helper';
import { RoadRageReelOverlay } from './RoadRageReelOverlay';
import { RoadRage } from '../RoadRage';
import { SoundConfig } from '../config/sound/SoundConfig';
import { SoundManager } from '../config/sound/SoundManager';

export class RoadRageEngineManager extends ReelEngineManager {

    private static _preferedLayoutSize: number = 3;
    private static changeRequest: boolean = false;
    public static movedOffsetY: number = 0;

    private bg_WIDTH: number = 1680;
    private bg_HEIGHT: number = 1680;

    private maskObj: PIXI.Graphics;

    protected static readonly reelDim: IDimOrientation = {
        landscape: {
            scale: new Point(1, 1),
            position: new Point(0, 160),
        },
        portrait: {
            scale: new Point(1, 1),
            position: new Point(0, 160)
        }
    };

    private buttonDebugi: DebugButton;

    private buttonChangePrefSize: DebugButton;


    static get wantsToSwitch(): boolean {
        return this.changeRequest;
    }

    static set wantsToSwitch(v) {
        this.changeRequest = v;
    }

    static get preferedLayoutSize(): number {
        return this._preferedLayoutSize;
    }

    static set preferedLayoutSize(v: number) {
        this.changeRequest = this.preferedLayoutSize !== v;
        this._preferedLayoutSize = v;
    }

    static get preferedSymSize():number{
        return [144, 126, 108][this.preferedLayoutSize - 3]
    }

    constructor(reelAmount: number, config: IReelConfig, initData: any, juri_time_calc: (value: number) => number) {
        super(reelAmount, config, initData, juri_time_calc);
    }

    protected init(amount: number, initData: any): void {
        super.init(amount, initData);

        if (GameSetting.isDevMode && false) {
            this.buttonDebugi = new DebugButton({
                size: new PIXI.Point(150, 50),
                textValue: "AddMult+1",
                cb: () => this.toggleFeatureBehaviour()
            })

            this.buttonChangePrefSize = new DebugButton({
                size: new PIXI.Point(200, 50),
                textValue: "Size: 5x3 - 144",
                cb: () => this.changeSize()
            })
            this.addChild(this.buttonChangePrefSize);
            this.addChild(this.buttonDebugi);

            this.buttonDebugi.position.set(360, -120);
            this.buttonChangePrefSize.position.set(150, -120);
        }
        this.maskObj = this.createGraphic();
        this.maskObj.name = "mask";
        this.maskObj.visible = false;
    }

    protected createGraphic(color: number = 0x000000, alpha: number = 1): PIXI.Graphics {

        // WIDTH: 144,
        // HEIGHT: 432,
        const w: number = 144 * this.AllReels.length;
        const h: number = 144;

        const ms: PIXI.Graphics = new PIXI.Graphics();
        ms.beginFill(color, alpha);
        ms.drawRect(-144, -h * 0.5,
            w + 144, h * 3);
        ms.endFill();
        this.addChild(ms);
        return ms;
    }

    static get isAnyoneChangingLayout() {
        return this.AllReels.findIndex((v) => v.layoutIsChanging) >= 0;
    }

    private coveringTL:gsap.core.Timeline;
    public miniCovering(enable:boolean):void{
        this.coveringTL = Helper.setTimeline(this.coveringTL);
        this.coveringTL.to(this,{ alpha: enable ? 0.1 : 1, duration: 1.8})
    }

    private toggleFeatureBehaviour(): void {
        this.buttonDebugi.changeText(
            this.buttonDebugi.name = ArrayHelper.fetchNextInList(this.buttonDebugi.name, ["AddMult+1", "Swear", "Nudge", "RNudge", "MiniPay"])
        );
        this.AllReels.forEach(r => r.changeInteraction(this.buttonDebugi.name));
    }

    changeSize(): void {

        this.buttonChangePrefSize.changeText(
            this.buttonChangePrefSize.name = ArrayHelper.fetchNextInList(this.buttonChangePrefSize.name, ["Size: 5x3 - 144", "Size: 5x4 - 126", "Size: 5x5 - 108"])
        );
        const currPos:number = ["Size: 5x3 - 144", "Size: 5x4 - 126", "Size: 5x5 - 108"].findIndex(v => v === this.buttonChangePrefSize.name);
        RoadRageEngineManager.preferedLayoutSize = 3 + currPos;
    }

    applyMask(val: boolean): void {
        this.mask = val ? this.maskObj : undefined!;
        this.maskObj.visible = val;
    }

    forcedRestoreSizeChange(restoreSize: number, setupPhase:boolean = false): void {

        this.forcedMaskSize(restoreSize);

        this.AllReels.forEach(r => r.restoreforcedSize(restoreSize, setupPhase));

        RoadRageReelOverlay.instance.reelSizeChange(restoreSize, RoadRageEngineManager.preferedSymSize);
    }

    get currAmountReelSize():number{
        return this.AllReels[0].config.WINDOW_AMOUNT;
    }

    forcedMaskSize(restoreSize: number): void {

        const stepDist: number = [144, 126, 108][restoreSize - 3];
        const sizeTo: number = restoreSize * stepDist;
        RoadRageEngineManager.movedOffsetY = stepDist != 144 ? (144 - stepDist) : 0;
        this.maskObj.position.y = RoadRageEngineManager.movedOffsetY;
        this.maskObj.height = sizeTo;

        this.onResize();
    }

    private movingTL:gsap.core.Timeline;

    private _moveVal:number = 0;
    private set moveVal(val:number){ this._moveVal = val; } 

    switchBgMovement(durr:number,fromLeft:boolean): void {
        const startX: number = this.dim.position.x;
        this.movingTL = Helper.setTimeline(this.movingTL, new gsap.core.Timeline({
            onUpdate:() =>{
                if(this.movingTL.progress() <= 0.5)
                    this.x = startX + Number(this._moveVal);
                else{
                    this.x = startX + (Number(this._moveVal) - Number(fromLeft ? -this.bg_WIDTH : this.bg_WIDTH));
                }
            }
        }));

        this.moveVal = startX;
        const startToX: number = this.dim.position.x + (fromLeft ? -this.bg_WIDTH : this.bg_WIDTH);

        this.movingTL.to(this, { moveVal: startToX, duration: durr });
        
        this.movingTL.to(this, { alpha: 0, duration: durr/4},0)
        this.movingTL.to(this, { alpha: 1, duration: durr/2},durr/2);

        this.changeMaskSize();

        RoadRageEngineManager.changeRequest = false;
    }

    private introTl:gsap.core.Timeline;
    playFirstIntro(): gsap.core.Timeline {
        this.introTl = Helper.setTimeline(this.introTl);

        SoundManager.playSoundEffect(SoundConfig.GAME_INTRO);
        
        const kp = this.parent.parent.children[2];

        this.introTl.add(RoadRage.backgroundElements.playNormalSwitch(true,1,true),0);

        const startReel:number = this.introTl.duration()*0.4;
        kp.visible = false;
        
        for(let row:number = 0; row < 3; row++){
            let carOffsetStart:number = startReel + row*0.3;
            RoadRageEngineManager.RAll((rc) => {
                rc.AllWindowSymbols.forEach(s => {
                    s.alpha = 0;
                    const fromLeft:boolean = row == 1;
                    this.introTl.add(RoadRage.overlayAnim.moveCarOnOverlay(fromLeft ,154 + row*160,"WC"+(row+1)), carOffsetStart);
                    if(s.posID[0] == row){
                        const offset = fromLeft ? 0.4 + (rc.reelID * 0.05) : 0.45 - (rc.reelID * 0.05);
                        this.introTl.to(s,{alpha:1,duration:0.15}, carOffsetStart + offset);
                    }
                });
            })
        }

        
        this.introTl.add(RoadRage.bgOverlay.playIntroLogo(),"-=1.4");

        this.introTl.add(() => { kp.visible = true },"-=1.1");
        this.introTl.fromTo(kp, {alpha:0}, { alpha:1, duration:0.45},"-=1.1");

        return this.introTl;
    }

    changeMaskSize(): void {
        
        const stepDist: number = [144, 126, 108][RoadRageEngineManager.preferedLayoutSize - 3];
        const sizeTo: number = RoadRageEngineManager.preferedLayoutSize * stepDist;

        RoadRageEngineManager.movedOffsetY = stepDist != 144 ? (144 - stepDist) : 0;

        gsap.to(this.maskObj, { y: RoadRageEngineManager.movedOffsetY, height: sizeTo, duration: 0.25 });
        gsap.to(this.position, { y: RoadRageEngineManager.dim.position.y + -RoadRageEngineManager.movedOffsetY / 2, duration: 0.25 });
    }

    public get dim(): LayoutDimData { return RoadRageEngineManager.dim; };
    public static get dim(): LayoutDimData { return ResizeHelper.calcDim(this.reelDim); };

    public static getReel(ID: number): RoadRageEngineController { return <RoadRageEngineController>super.getReel(ID); };
    public static get AllReels(): RoadRageEngineController[] { return <RoadRageEngineController[]>this._reels; };
    public get AllReels(): RoadRageEngineController[] { return <RoadRageEngineController[]>ReelEngineManager.AllReels; };

    public static RSWindow(func: (rc: RoadRageEngineController, sym: RoadRageSpriteSymbol) => void): void {
        this.RAll((rc: RoadRageEngineController) => {
            for (let symID: number = 0; symID < rc.AllWindowSymbols.length; symID++)
                func(rc, rc.AllWindowSymbols[symID]);
        });
    };

    public static RSAll(func: (rc: RoadRageEngineController, sym: RoadRageSpriteSymbol) => void): void {
        this.RAll((rc: RoadRageEngineController) => {
            for (let row: number = 0; row < rc.AllVisibleSymbols.length; row++)
                func(rc, rc.AllVisibleSymbols[row]);
        });
    };

    public static RAll(func: (rc: RoadRageEngineController) => void): void {
        for (let reel: number = 0; reel < this.AllReels.length; reel++) {
            func(this.AllReels[reel]);
        }
    };

    protected createReel(ID: number, initData: ReelGameData): RoadRageEngineController {
        return new RoadRageEngineController(ID, this.reelConfig, initData);
    }


    onResize(): void {
        this.AllReels.forEach((reel) => { reel.onResize(); });
        this.position = this.dim.position;
        this.position.y = this.dim.position.y + -RoadRageEngineManager.movedOffsetY / 2;
        this.scale = this.dim.scale;
    }
}